import { Button, ButtonGroup } from '@mui/material';
import { contractService } from 'services/api';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import { Link } from 'react-router-dom';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import TenantPage from 'components/common/TenantPage';
import { PurgeButton } from 'components/helpers/PurgeButton';
import { IsSuperAdmin } from 'components/helpers/IsSuperAdmin';
import ImportFileUploader from 'components/common/file-uploader/ImportFileUploader';
import { GridColDef } from '@mui/x-data-grid-premium';
import { ContractLinesAllColumns } from 'components/common/enhanced/common-headers/contract-lines-all';
import { isSupplier } from 'components/helpers/IsSupplier';

export const Contracts = () => {
  const translationPrefix = 'pages.contract.list';
  const { t } = useTranslation();

  const datagridRefresh = useRef(null);
  const isSupplierRole = isSupplier();

  const columns: GridColDef[] = ContractLinesAllColumns(contractService);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              <IsTenantAdministrator>
                <Link to="new">
                  <Button variant="outlined" size="small">
                    <AddIcon />
                    {t(`${translationPrefix}.add-new`)}
                  </Button>
                </Link>
              </IsTenantAdministrator>
              <IsSuperAdmin>
                <ImportFileUploader
                  service={contractService}
                  importMethod={contractService.importAggregatedLinesFromFile}
                  templateGetterMethod={contractService.getAggregatedImportTemplate}
                />
              </IsSuperAdmin>
            </ButtonGroup>
            <PurgeButton service={contractService} refresh={datagridRefresh} />
          </div>
        }>
        <div className="mt-6">
          <EnhancedDataGrid
            columns={columns}
            service={contractService}
            refresh={datagridRefresh}
            disableEdit={!isSupplierRole}
            disableExport={true}
          />
        </div>
      </TenantPage>
    </>
  );
};

export default Contracts;
